import { render, staticRenderFns } from "./DemoConfigShowDetailsCard.vue?vue&type=template&id=3a728730"
import script from "./DemoConfigShowDetailsCard.vue?vue&type=script&lang=ts"
export * from "./DemoConfigShowDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports